import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';

import { AskPredefinedTemplate } from '@core/ask-hr-templates-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { EmptyStateComponent } from '@core/user-interface-legacy';

import { AddNewTemplateComponent } from '../../add-new-template/add-new-template.component';
import { AskTemplatesDialogService } from '../../ask-templates-dialog.service';

@Component({
  selector: 'ask-hr-templates-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-empty-state
      [title]="'tlc.ask_hr.forms.empty_state.heading' | translate"
      [desc]="'tlc.ask_hr.forms.empty_state.subheading' | translate"
    />
    <div class="container">
      <ask-hr-add-new-template class="predefined" (selectedTemplate)="onTemplateSelect($event)" />
    </div>
  `,
  styleUrl: './empty-state.component.less',
  imports: [TranslatePipe, EmptyStateComponent, AddNewTemplateComponent],
})
export class AskHEmptyStateComponent {
  private readonly injector = inject(Injector);

  private readonly askTemplatesDialogService = inject(AskTemplatesDialogService);

  protected onTemplateSelect(template: AskPredefinedTemplate | null) {
    this.askTemplatesDialogService.openCreateTemplateDialog(this.injector, template);
  }
}
